// extracted by mini-css-extract-plugin
module.exports = {"container":"StickyBar_container__37gPz","content":"StickyBar_content__3nnZf","coolButton":"StickyBar_coolButton__1-R76","btn-animation":"StickyBar_btn-animation__3D7SG"};